// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__y_Tvw","Spinner":"Loader_Spinner__179Fb","s3":"Loader_s3__1VpG7"};